// @flow

import { createSelector } from 'reselect'
import { applicationFlags } from '../constants'

export const getCurrentOrganization: Function = createSelector(
  [state => state.auth.user && state.auth.user.organizations, state => state.organization.orgId],
  (organizations, currentOrgId): Object =>
    organizations && organizations.find(org => org.id === currentOrgId)
)

export const isCurrentOrganizationArtifactSizeEnabled: Function = createSelector(
  state => getCurrentOrganization(state),
  (organization): boolean =>
    organization &&
    organization.application_flags &&
    organization.application_flags.includes(
      applicationFlags.displayArtifactSize
    )
)

export const isCurrentOrganizationSchedulesEnabled: Function = createSelector(
  state => getCurrentOrganization(state),
  (organization): boolean =>
    organization.application_flags &&
    organization.application_flags.includes(applicationFlags.displaySchedules)
)

export const isCurrentOrganizationEstimatedJourneyCompletionDateEnabled: Function = createSelector(
  state => getCurrentOrganization(state),
  (organization): boolean =>
    organization.application_flags &&
    organization.application_flags.includes(
      applicationFlags.displayEstimatedJourneyCompletionDate
    )
)

export const isCurrentOrganizationTermReportsEnabled: Function = createSelector(
  state => getCurrentOrganization(state),
  (organization): boolean =>
    organization.application_flags &&
    organization.application_flags.includes(applicationFlags.displayTermReports)
)

export const isCurrentOrgSetDefaultStudentLocation: Function = createSelector(
  state => getCurrentOrganization(state),
  (organization): boolean =>
    organization.application_flags &&
    organization.application_flags.includes(applicationFlags.studentLocationByDefaultRemote)
)

export const isCurrentOrginizationMentorLoomRecordingEnabled: Function = createSelector(
  state => getCurrentOrganization(state),
  (organization): boolean =>
    organization && organization.application_flags &&
    organization.application_flags.includes(applicationFlags.enableMentorLoomRecording)
)

export const isCurrentOrginizationStudentLoomRecordingEnabled: Function = createSelector(
  state => getCurrentOrganization(state),
  (organization): boolean =>
    organization && organization.application_flags &&
    organization.application_flags.includes(applicationFlags.enableStudentLoomRecording)
)

export const isCurrentOrginizationRequiredSkillsChecksEnabled: Function = createSelector(
  state => getCurrentOrganization(state),
  (organization): boolean =>
    organization && organization.application_flags &&
    organization.application_flags.includes(applicationFlags.enableRequiredSkillsChecks)
)

export const isCurrentOrginizationPerformanceTabEnabled: Function = createSelector(
  state => getCurrentOrganization(state),
  (organization): boolean =>
    organization && organization.application_flags &&
    !organization.application_flags.includes(applicationFlags.hideStudentPerformanceTab)
)

export const isCurrentOrginizationMentorViewPerformanceTabEnabled: Function = createSelector(
  state => getCurrentOrganization(state),
  (organization): boolean =>
    organization && organization.application_flags &&
    !organization.application_flags.includes(applicationFlags.hideMentorViewPerformanceTab)
)

export const isCurrentOrginizationMentorsOverrideCheckpointsEnabled: Function = createSelector(
  state => getCurrentOrganization(state),
  (organization): boolean =>
    organization && organization.application_flags &&
    organization.application_flags.includes(applicationFlags.enableMentorsOverrideCheckpoints)
)
